import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import { format } from 'date-fns';
import React from 'react';

import { PrizeCurrency, TimedStatus } from '@swf/casino';
import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import Duration from '@swf/components/Duration/Duration';
import FSBIcon from '@swf/core/assets/casino/free-spins.png';
import ibIcon from '@swf/core/assets/casino/instant-bonus.png';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { PrizeType, RaceType } from '@swf/core/types/CasinoRaces';
import { isCompleted, isRunning } from '@swf/core/utils/casino';

import {
  TXTMOB_Min_BetX,
  TXTWCL_DurationX,
  TXTWCL_Ends_InX,
  TXTWCL_Starts_InX,
  TXTWCL_Total_PrizesX
} from './Info.messages.json';
import styles from './Info.scss';

export interface Props {
  race: CasinoRace;
  count: number;
  onLeaderboard?(): void;
}

const Info: React.FC<Props> = ({ race, onLeaderboard, count }) => {
  const { startTime, endTime, minBet, status, prizeDetails, raceTypes } = race;
  const running = isRunning(status);
  const completed = isCompleted(status);

  return (
    <div className={classNames(styles.wrapper, { [styles.wrapperLeaderboard]: !onLeaderboard })}>
      <div className={classNames(styles.box, styles.prizeGrid)}>
        <div className={styles.info}>
          <Translation {...TXTWCL_Total_PrizesX} />
        </div>
        <div className={classNames(styles.infoExtraLarge, styles.prizes)}>
          {prizeDetails.prizeType === PrizeType.IB && (
            <div>
              <img className={styles.ibIcon} src={ibIcon} alt="" />
            </div>
          )}
          {prizeDetails.prizeType === PrizeType.FSB && (
            <div>
              <img className={styles.fsbIcon} src={FSBIcon} alt="" />
            </div>
          )}
          <PrizeCurrency
            type={prizeDetails.prizeType}
            currency={prizeDetails.currency}
            amount={prizeDetails.total}
          />
        </div>
      </div>
      <div className={classNames(styles.box, styles.boxGrid, styles.shrink)}>
        <div className={classNames(styles.info, completed ? styles.running : styles.infoDefault)}>
          {completed ? (
            format(endTime, 'LL.dd.yyyy')
          ) : running ? (
            <Translation {...TXTWCL_Ends_InX} />
          ) : (
            <Translation {...TXTWCL_Starts_InX} />
          )}
        </div>
        <div className={styles.infoExtraLarge}>
          <span className={classNames(running || completed ? styles.running : styles.remaining)}>
            <TimedStatus
              completed={completed}
              running={running}
              endTime={endTime}
              startTime={startTime}
              count={count}
              urgentCount
            />
          </span>
        </div>
      </div>
      <div className={classNames(styles.box, styles.boxGrid)}>
        <div className={classNames(styles.info, styles.infoDefault)}>
          <Translation {...TXTWCL_DurationX} />
        </div>
        <div className={styles.infoLarge}>
          <span>
            <Duration time={{ endTime, startTime }} />
          </span>
        </div>
      </div>
      <div className={classNames(styles.box, styles.boxGrid)} />
      {!raceTypes.includes(RaceType.LDCNT) && (
        <div className={classNames(styles.box, styles.boxGrid, styles.shrink)}>
          <div className={classNames(styles.info, styles.infoDefault)}>
            <Translation {...TXTMOB_Min_BetX} />
          </div>
          <div className={styles.infoLarge}>
            <span>
              <CurrencyAmount value={minBet} currency={prizeDetails.currency} style="decimal" />
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Info;
